import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  calendar: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    position: 'relative',
  },
  dayLabel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontSize: '14px',
    color: '#3C419A',
    fontWeight: 700,
    width: '14%',
    height: '30px',
    background: 'rgba(202, 202, 252, 0.5)',
    border: 'solid 1px rgba(202, 202, 252, 0)',
  },
  cell: {
    width: '14%',
    height: '140px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
  },
  date: {
    textAlign: 'right',
    fontFamily: 'Roboto',
    fontSize: '18px',
    padding: '15px',
  },
  currentMonth: {
    backgroundColor: '#FFFFFF',
  },
  currentDate: {
    float: 'right',
    right: '0px',
    color: '#FFFFFF',
    backgroundColor: '#3C419A',
    borderRadius: '100%',
    margin: '10px',
    padding: '5px',
    textAlign: 'center',
    width: '20px',
    height: '20px',
  },
  otherMonth: {
    backgroundColor: '#FAFBFF',
  },
  currentMonthDate: {
    color: '#2C2D3E',
  },
  otherMonthDate: {
    color: 'rgba(60, 65, 154, 0.6)',
  },
  eventBadge: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    height: '30px',
    width: '100%',
    marginBottom: '12px',
    position: 'relative',
    cursor: 'pointer'
  },
  eventStartBadge: {
    marginLeft: '12px',
    width: 'calc(100% - 12px)',
    borderRadius: '5px 0px 0px 5px',
  },
  eventEndBadge: {
    width: 'calc(100% - 14px)',
    borderRadius: '0px 5px 5px 0px',
  },
  eventOneDayBadge: {
    marginLeft: '12px',
    width: 'calc(100% - 24px)',
    borderRadius: '5px',
  },
  eventLabel: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: '10px', 
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 700,
    textAlign: 'left',
    zIndex: 10,
  },
  eventTime: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 400,
    paddingLeft: '10px',
  },
  addProcedureIconContainer: {
    position: 'relative',
    top: '-39px',
    left: 'calc(100% - 40px)',
    width: '5px',
    height: '5px'
  },
  addProcedureIcon: {
    width: '100%',
    zIndex: 100,
    cursor: 'pointer'
  }
}));
